import { FC } from 'react';
import { Backdrop, Modal, Slide } from '@mui/material';
import ShareItems from './Items';
import './styles.scss';
import './media.scss';

interface IProps {
  url: string;
  open: boolean;
  onClose: () => void;
  className: string;
}

const ShareModal: FC<IProps> = ({ open, onClose, url, className }) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      BackdropComponent={Backdrop}
      closeAfterTransition
      sx={{ display: 'flex', flexDirection: 'column' }}
    >
      <Slide direction='down' in={open} mountOnEnter unmountOnExit>
        <div className={`share-modal ${className}`}>
          <ShareItems url={url} />
        </div>
      </Slide>
    </Modal>
  );
};
export default ShareModal;
